import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const TrialBanner = ({ trialDaysLeft, isTrialExpired, isSuspended, onDismiss }) => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  if (isSuspended || isTrialExpired) {
    return (
      <div className="bg-red-600 text-white px-4 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-1">
          <Icon name="AlertOctagon" size={16} color="currentColor" />
          <span className="text-sm font-medium">
            Your trial has expired. Please add a payment method to continue using RIGJOCKEY.
          </span>
        </div>
        <button
          onClick={() => navigate('/subscription-billing')}
          className="shrink-0 px-4 py-1.5 bg-white text-red-600 rounded-lg text-sm font-semibold hover:bg-red-50 transition-colors"
        >
          Add Payment Method
        </button>
      </div>
    );
  }

  if (trialDaysLeft !== null && trialDaysLeft <= 5) {
    const urgency = trialDaysLeft <= 1 ? 'bg-orange-600' : 'bg-amber-500';
    return (
      <div className={`${urgency} text-white px-4 py-2.5 flex items-center justify-between gap-4`}>
        <div className="flex items-center gap-2 flex-1">
          <Icon name="Clock" size={16} color="currentColor" />
          <span className="text-sm font-medium">
            {trialDaysLeft === 0
              ? 'Your free trial expires today!'
              : `Your free trial expires in ${trialDaysLeft} day${trialDaysLeft === 1 ? '' : 's'}.`}
            {' '}Add a payment method to keep your account active.
          </span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => navigate('/subscription-billing')}
            className="px-4 py-1.5 bg-white text-amber-700 rounded-lg text-sm font-semibold hover:bg-amber-50 transition-colors"
          >
            Upgrade Now
          </button>
          <button onClick={handleDismiss} className="p-1 hover:bg-white/20 rounded transition-colors">
            <Icon name="X" size={14} color="currentColor" />
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default TrialBanner;
